import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AsyncSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UpgradesService {
  private cache$: AsyncSubject<any>;
  constructor(private readonly apiService: ApiService) {}

  getUpgrades(inspectionId: string, headers: { [header: string]: string | string[] } = {}) {
    if (this.cache$) {
      return this.cache$.asObservable();
    }

    this.cache$ = new AsyncSubject();

    this.apiService.get(`/inspections/${inspectionId}/upgrades`, headers).subscribe((res) => {
      this.cache$.next(res);
      this.cache$.complete();
      this.cache$ = null;
    });

    return this.cache$.asObservable();
  }
}
